//Constantes de cod_empresa para customizações
export const SAO_CAMILO = 571;
export const UNISC = 87;
export const CJF = 523;